(function() {

    'use strict';

    /**
     * Product information extended
     * @name itxProductInformationExtended
     * @type ProductInformationExtendedCmp
     */
    var ProductInformationExtendedCmp = {
        controller: ProductInformationExtendedCmpCtrl,
        bindings: {
            product: '<'
        },
        controllerAs: '$ctrl',
        templateUrl: 'product-information-extended.component.html'
    };

    ProductInformationExtendedCmpCtrl.$inject = [
        'ItxStaticResourceSvc'
    ];

    function ProductInformationExtendedCmpCtrl(ItxStaticResourceSvc) {

        var _this = this;

        // Función para generar la imagen de información extendida
        _this.generateImageUrl = function() {

            var imageUrl = ItxStaticResourceSvc.getImage('pao/' + _this.product.perfum.pao + '.png', false);

            return imageUrl;

        };

     }

    /** Public */
    angular.module('itxApp.catalog')
        .component('itxProductInformationExtended', ProductInformationExtendedCmp);

})(); 
